import {
  TKwikUIInputSelectSize,
  VKwikUIInputSelectSize
} from "./input-select.definitions";

export const isValidKeyValue = (key: string, value: any): boolean => {
  const { isArray } = Array;
  const isBoolean = (x: boolean) => typeof x === "boolean";
  const isString = (x: string) => typeof x === "string";

  const methods = {
    disabled: isBoolean,
    focus: isBoolean,
    formControlName: isString,
    hintContent: isString,
    icon: isString,
    id: isString,
    invalid: isBoolean,
    label: isString,
    options: isArray,
    placeholder: isString,
    postfix: isString,
    prefix: isString,
    searchable: isBoolean,
    size: (x: TKwikUIInputSelectSize) => VKwikUIInputSelectSize.includes(x)
  };

  return methods[key] && methods[key](value);
};
